<!--
 * @title:
 * @fileName: RouterTools
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/5/20 19:24
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
    <div id="_2020">
        <ul class="router-tools-paths-container bounce" v-if="itemsShow">
            <li v-for="(path,index) in items" class="router-tools-paths-item" :key="index"
                @click="onItemsClick(path, index)" @click.right="onItemsClickRight(path, index)">
                {{path._name}}
            </li>
        </ul>
        <div v-if="allowShow && !itemsShow"  class="router-tools-container bounce-hover" @click="onClick" @click.right="onClickRight">
        </div>
    </div>
</template>

<script>
class Path {
    constructor(name, path) {
        this._name = name
        this._path = path
    }

    get name () {
        return this._name
    }
    get path () {
        return this._path
    }
    equal (value) {
        if (value){
            if (value.name === this.name){
                if (value.path === this.path){
                    return true
                }
            }
        }
        return false
    }
}
export default {
    name: "RouterTools",
    data() {
        return {
            dialogShow: false,
            localStorageName: 'testPath',
            itemsShow: false,
            items: []
        }
    },
    computed: {
        allowShow () {
            return process.env.NODE_ENV !== 'production'
        },
        routerList () {
            return this.$router
        }
    },
    methods: {
        onClick() {
            if (window.localStorage){
                const pathStr = window.localStorage.getItem(this.localStorageName)
                let paths = [],
                    path = new Path(this.$route.meta.title,this.$route.path)
                try {
                    paths = JSON.parse(pathStr)
                    if (Array.isArray(paths)){
                        if (paths.length === 1){
                            path = paths[0]
                        }else{
                            this.items = paths
                            this.itemsShow = true
                            return
                        }
                    }
                }catch (e) {

                }
                this.items = []
                this.$router.push({path: path._path})
            }
        },
        onClickRight() {
            if (window.localStorage){
                const pathStr = window.localStorage.getItem(this.localStorageName),
                    path = new Path(this.$route.meta.title,this.$route.path)
                let paths = []
                if (!this.Tools.get().StringTools.isNullOrEmpty(pathStr)){
                    try {
                        paths = JSON.parse(pathStr)
                        let result = true
                        for (let i = 0; i < paths.length; i++) {
                            if (paths[i]._path === path._path){
                                result = false
                                break
                            }
                        }
                        if (result){
                            paths.push(path)
                        }
                    }catch (e) {
                        paths.push(path)
                    }
                }else{
                    paths.push(path)
                }
                window.localStorage.setItem('testPath', JSON.stringify(paths))
            }
        },
        onItemsClick (path, index) {
            this.itemsShow = false
            this.$router.push({path: path._path})
        },
        onItemsClickRight (path, index) {
            this.items.splice(index,1)
            if (window.localStorage){
                window.localStorage.setItem('testPath', JSON.stringify(this.items))
            }
            this.itemsShow = false
        }
    },
    mounted() {
        this.$nextTick(() => {
            const body = document.querySelector("body");
            if (body.append) {
                body.append(this.$el);
            } else {
                body.appendChild(this.$el);
            }
        })
        try {
            document.querySelector('#_2020')
                .oncontextmenu = function(){
                return false;
            }
            document.querySelector('.router-tools-container')
                .oncontextmenu = function(){
                return false;
            }
            document.querySelector('.router-tools-paths-container')
                .oncontextmenu = function(){
                return false;
            }
            document.querySelector('.router-tools-paths-item')
                .oncontextmenu = function(){
                return false;
            }
        }catch (e) {

        }
    }
}
</script>

<style scoped lang="scss">
$main-background-color: #00aeef;
.router-tools-container{
    z-index: 20000928;
    width: 50px;
    height: 50px;
    position: fixed;
    top: auto;
    left: auto;
    right: 18px;
    bottom: 18px;
    background-color: $main-background-color;
    border-radius: 50%;
    box-shadow: 0 0 10px 1px rgba(0,0,0, 0.3);
}
.router-tools-paths-container{
    z-index: 20000928;
    position: absolute;
    top: auto;
    left: auto;
    right: 24px;
    bottom: 24px;
    height: 200px;
    min-width: 100px;
    background-color: $main-background-color;
    box-shadow: 0 0 10px 1px rgba(0,0,0, 0.3);
    border-radius: 10px;
    list-style: none;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: auto;
    .router-tools-paths-item {
        width: 100%;
        height: 32px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #00e1ff;
        color: #F6F6F6;
        cursor: pointer;

    }
    .router-tools-paths-item:hover {
        box-shadow: 0 0 10px 1px rgba(0,0,0, 0.3);
    }
}
.router-tools-container:active{
    transition:background-color .1s;
    background-color: #b8e9ff;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/TestTools/RouterTools.vue"
}
</vue-filename-injector>
